import { z } from 'zod';

const isoInstant = z.iso.datetime({ offset: true });

/** A moment on the wire is its ISO string; the server may hand it the `Date` it read. */
export const instant = z.codec(z.union([z.date(), isoInstant]), isoInstant, {
  decode: (at) => (at instanceof Date ? at.toISOString() : at),
  encode: (at) => at,
});

/**
 * A row as `schema` puts it on the wire: its keys alone, in its order, each `Date` written as the
 * instant it is. Typed by what the schema takes, so a row that drifts from it fails to compile.
 */
export function project<S extends z.ZodObject>(schema: S, row: z.input<S>): z.output<S> {
  const from = row as Record<string, unknown>;
  return Object.fromEntries(
    Object.keys(schema.shape).map((key) => {
      const value = from[key];
      return [key, value instanceof Date ? value.toISOString() : value];
    }),
  ) as z.output<S>;
}

export const day = z.iso.date();

export const price = z.number().positive();

export const requestTokenSchema = z.string().trim().min(8).max(128);

const monthSchema = z.object({ tradingsymbol: z.string(), expiry: z.string().nullable() });

export const monthMoveSchema = z.object({
  from: monthSchema,
  to: monthSchema.extend({ token: z.number().int() }).nullable(),
  refusal: z.string().nullable(),
});

export type MonthMove = z.infer<typeof monthMoveSchema>;
